import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import { X as CloseIcon } from 'lucide-react';

/**
 * Slide-over right side modal drawer (matching Live Transactions inspector style)
 */
export default function TransitionsModal({ open, toggleModal, children, title, width }) {
  return (
    <Drawer
      anchor="right"
      open={Boolean(open)}
      onClose={toggleModal}
      PaperProps={{
        sx: {
          width: width || { xs: '100%', sm: 480, md: 560 },
          maxWidth: '100vw',
          height: '100%',
          bgcolor: 'background.paper',
          p: 0,
          overflowY: 'auto',
          boxShadow: '-8px 0 32px rgba(0, 0, 0, 0.12)',
          borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      <Box sx={{ p: { xs: 2.5, sm: 3.5 }, height: '100%', display: 'flex', flexDirection: 'column' }}>
        {title && (
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2.5 }}>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 800 }}>
              {title}
            </Typography>
            <IconButton onClick={toggleModal} size="small" sx={{ bgcolor: 'action.hover' }}>
              <CloseIcon size={18} />
            </IconButton>
          </Stack>
        )}
        {children}
      </Box>
    </Drawer>
  );
}

TransitionsModal.propTypes = {
  open: PropTypes.bool,
  toggleModal: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
};
